<template lang="pug">
.page-menu-w.flex.justify-between.bg-canvas-200.rounded-lg.p-0(class="md:rounded-xl lg:rounded-3xl")
  .flex.flex-wrap
    RouterLink.text-link(
      v-for="(item, idx) in itemsLeft"
      :to="item.route" 
      :target="props.target"
    )
      Button.p-button-sm(
        :class="[isRouteActive(item.route) ? 'is-active' : '', 'min-w-[10rem]']"
        :label="item.label"
        :icon="item.icon"
        :key="item.key"
        :badge="item.badge !== undefined ? `${item.badge}` : null")
  .flex.flex-wrap
    template(v-for="(item, idx) in itemsRight" :key="item.key")
      RouterLink.text-link(v-if="item.route" :to="item.route" :target="props.target")
        Button.p-button-sm(
          :class="[isRouteActive(item.route) ? 'is-active' : '', 'min-w-[10rem]']"
          :label="item.label"
          :icon="item.icon"
          :badge="item.badge ? `${item.badge}` : null"
        )
      Button.p-button-sm(
        v-else-if="item.command"
        :class="['min-w-[10rem]']"
        :label="item.label"
        :icon="item.icon"
        :badge="item.badge ? `${item.badge}` : null"
        @click="item.command"
      )
  //- pre activeKey: {{ route.path }}
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  itemsLeft:  { type: Array, default: [] },
  itemsRight: { type: Array, default: [] },
})

const route = useRoute()

const isRouteActive = (routePath) => {
  return route.path === routePath
}

const allItems = computed(() => {
  return [...props.itemsLeft, ...props.itemsRight]
})
</script>

<style lang="scss">
$btn-radius: 0.75rem;
$btn-active-bg:     var(--p-sky-500);
$btn-active-txt:    var(--p-button-info-color);
$btn-inactive-bg:   transparent;
$btn-inactive-txt:  var(--color-canvas-600);
$btn-inactive-bor:  var(--color-canvas-200);

.page-menu-w {

  .p-button {
    margin: 3px;
    border-radius: 2rem;
    border: none;
    background-color: $btn-inactive-bg;
    color: $btn-inactive-txt;      
    &.is-active {
      background-color: $btn-active-txt;
      color: $btn-active-bg;
    }

    /* Hover effects ONLY apply to devices that support true hovering */
    @media (hover: hover) {
      &:hover {
        background-color: rgba(0, 0, 0, 8%);
      }
    }
  }

}
</style>